const students = {
  students: "Lernende",
  definePassword: "Ein Passwort festlegen",
  pendingActivation: "Wartet auf Aktivierung",
  passwordRequired: "Passwort erforderlich",
  student: "Lernende",
  studentDetail: "Details zum Lernenden",
  studentsList: "Liste der Lernenden",
  newStudentsList: "Liste der neuen Lernenden",
  importStudents: "Lernende importieren",
  welcomeStudentPersonalHome: "Willkommen in deinem persönlichen Bereich",
  selectStudentInList:
    "Wählen Sie einen vorhandenen Lernenden aus der Liste aus.",
  studentNotActivated: "Dieser Lernende hat sein Konto noch nicht aktiviert.",
  studentNotSubscribed: "Dieser Lernende ist nicht abonniert.",
};

export default students;
